//@ts-check
import axios from 'api/axios'
import ThemeManager from 'theming/ThemeManager'
import { useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 * Hook that fetch the my_users_data
 * @function
 * @param {number} [page=1]
 * @param {number} [page_size=13]
 * @param {NewsCategories | undefined} [category]
 * @param {Array<NewsTags> | undefined} [tags]
 * @returns {import('common/types/connections_types').UseFetchHookResponse<NewsDTOResponse | undefined>}
 */
const useFetchComunicados = (
  page = 1,
  category,
  tags,
  search = '',
  page_size,
  dateFrom = null,
  dateTo = null,
  id = null,
) => {
  const Theme = new ThemeManager()
  const size = Theme.options?.newsOptions?.pageSize ?? page_size
  const [response, setResponse] = useState()

  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }
    setLoading(true)
    axios
      .get(
        `/comunicados?page=${page}&page_size=${page_size ?? size ?? ''}&c=${category?.id ?? ''}&t=${
          tags ? tags.map((t) => t.id).join(',') : ''
        }&s=${search || ''}&fd=${dateFrom?.toISOString() || ''}&fh=${
          dateTo?.toISOString() || ''
        }&i=${id || ''}`,
      )
      .then((/**@type {import('axios').AxiosResponse<NewsDTOResponse>}*/ request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loading) fetchData()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, category, tags, page_size, search, dateTo, dateFrom])

  return { response, error, loading }
}

export default useFetchComunicados
